export const DirectionDepartEnum=Object.freeze({
    now: "now",
    at: "at"
})